module.exports = __webpack_public_path__ + "static/media/info3.f310d4c3.png";